import CountryPageRenderer from '../components/CountryPageRenderer';
import malaysiaData from '../data/country-pages/malaysia';

export default function MalaysiaCountryPage() {
  return <CountryPageRenderer data={malaysiaData} />;
}
